import React from "react";

/**
 * Five analytics flag cards computed from the 7-day window.
 * All props are pre-computed by DeploymentMatrixTab — no logic here.
 *
 * Props:
 *   analytics: {
 *     criticalCount: number,     // gyms with >= 1 red cell
 *     overstaffedCount: number,  // gyms with >= 1 purple cell
 *     bestGymName: string,       // gym with most green cells
 *     bestGymStreak: number,     // consecutive green-cell days
 *     absenteeCount: number,     // gyms with repeat absentees
 *     networkAvg: string,        // e.g. "5.8"
 *     networkGymCount: number,
 *   }
 *   activeFilter: string | null  — which filter is active ("critical" | "overstaffed" | "best" | "absentee" | null)
 *   onFilter: (key: string) => void  — toggle filter
 */
const CARDS = [
  {
    key: "critical",
    modifier: "critical",
    label: "Critical Gyms",
    getValue: (a) => a.criticalCount,
    getSub: (a) => `below min today`,
  },
  {
    key: "overstaffed",
    modifier: "overstaffed",
    label: "Overstaffed",
    getValue: (a) => a.overstaffedCount,
    getSub: () => "> 6 staff any day",
  },
  {
    key: "best",
    modifier: "best",
    label: "Best Gym",
    getValue: (a) => a.bestGymName || "—",
    getSub: (a) => a.bestGymName ? `${a.bestGymStreak}/7 days green` : "no data",
  },
  {
    key: "absentee",
    modifier: "",
    label: "Repeat Absentees",
    getValue: (a) => a.absenteeCount,
    getSub: () => "gyms with issues",
  },
  {
    key: "avg",
    modifier: "",
    label: "Network Avg",
    getValue: (a) => `${a.networkAvg} / 6`,
    getSub: (a) => `across ${a.networkGymCount} gyms`,
  },
];

const MatrixFlagCards = ({ analytics, activeFilter, onFilter, onCardClick = () => {} }) => {
  if (!analytics) return null;

  return (
    <div className="sdm-flags">
      {CARDS.map(({ key, modifier, label, getValue, getSub }) => (
        <div
          key={key}
          className={`sdm-flag-card${modifier ? ` sdm-flag-card--${modifier}` : ""}${activeFilter === key ? " sdm-flag-card--active" : ""}`}
          onClick={() => { onFilter(key); onCardClick(key); }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onFilter(key);
              onCardClick(key);
            }
          }}
          aria-pressed={activeFilter === key}
        >
          <div className="sdm-flag-card__label">{label}</div>
          <div className="sdm-flag-card__value">{getValue(analytics)}</div>
          <div className="sdm-flag-card__sub">{getSub(analytics)}</div>
        </div>
      ))}
    </div>
  );
};

export default MatrixFlagCards;
